/**
 * savedLayoutMenu — the shared per-row "manage a saved layout" menu definition (v1.5). Used by both
 * the desktop sidebar (MCPlaybackDesktopSidebar) and the camera drawer (CameraDrawer) so the two
 * surfaces never drift. Each surface owns its own inline-rename state + className set; this module
 * just centralizes the icons + the ActionsMenu item list (the part most likely to diverge).
 */

// Material icon paths (ActionsMenu renders each item's `path` as an <svg viewBox="0 0 24 24">).
export const LAYOUT_MENU_ICONS = {
  edit: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z',
  replace: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z',
  trash: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z',
};

/**
 * Build the ActionsMenu items for one saved layout.
 * @param name      the layout's name (for the Delete title)
 * @param onRename  start inline-rename
 * @param onReplace overwrite the layout's cam set with the current grid
 * @param onDelete  remove the layout
 */
export const buildLayoutMenuItems = ({ name, onRename, onReplace, onDelete }) => [
  { action: 'rename', label: 'Rename', title: 'Rename layout', path: LAYOUT_MENU_ICONS.edit, onClick: onRename },
  { action: 'replace', label: 'Replace with current cameras', title: 'Overwrite this layout with the current cameras', path: LAYOUT_MENU_ICONS.replace, onClick: onReplace },
  { action: 'delete', label: 'Delete', title: `Delete ${name}`, path: LAYOUT_MENU_ICONS.trash, onClick: onDelete },
];
